import { defineComponent, Ref, ref, onMounted } from 'vue'
import './style.sass'

export default defineComponent({
  props: {
    options: {
      type: Array,
      default: () => []
    },
    value: {
      type: String || Number,
      default: ''
    },
    link: {
      type: String,
      default: ''
    },
    onSelectChange: {
      type: Function,
      default: (value: string) => { return value }
    }
  },

  setup (props: any, context: any) {
    const newValue = ref(props.value)
    const active = ref(false)
    const selectRoot = ref(null) as unknown as Ref<HTMLElement>

    onMounted(() => {
      newValue.value = props.value
      window.addEventListener('click', (e) => {
        if (!selectRoot.value) return
        if (!selectRoot.value.contains(e.target as HTMLElement)) {
          active.value = false
        }
      })
    })

    function toggle (e: any) {
      if (active.value) active.value = false
      else active.value = true
      e.preventDefault()
    }

    function select (option: any, idx: any, e: any) {
      newValue.value = option.title
      props.onSelectChange(option)
      toggle(e)
    }

    return () => {
      return (
        <div class={ `select ${active.value ? 'open' : ''}` } ref={selectRoot} onClick={(e) => toggle(e)}>
          {!props.options.length ? (
            <div class="selected">
              <div class="left">
                <a href={props.link}>{ props.value }</a>
              </div>
            </div>
          ) : (
            <div class="selected-wrap">
              <div class="selected">
                <div class="left">
                  <span>{ newValue.value }</span>
                </div>
                <div class="right">
                  <img src={require('./assets/select-arrow.svg')} />
                </div>
                {active.value ? (
                  <div class="options">
                    {props.options.map((item: any, id: number) => (
                      <div
                        class={ { option: true, active: item.title === newValue.value } }
                        onClick={ (e) => select(item, id, e) }
                      >
                        <a href="/">{ item.title }</a>
                      </div>
                    ))}
                  </div>
                ) : null}
              </div>
            </div>
          )}
        </div>
      )
    }
  }
})
